import React from 'react';
import { Modal } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import BackButton from '@/components/buttons/BackButton';
import CloseButton from '@/components/buttons/CloseButton';
import ForwardButton from '@/components/buttons/ForwardButton';
import SaveButton from '@/components/buttons/SaveButton';
import { states } from '@/constants/lifecycle';
import { nextCarouselIndex, previousCarouselIndex, removeEmpty } from '@/utils/resultsHelper';

const FormObjectActions = ({
  activeIndex,
  canEdit,
  changeItem,
  isDirty,
  items,
  onClose,
  onSave,
  saveStatus,
}) => {
  const intl = useIntl();
  return (
    <Modal.Actions>
      <CloseButton onClick={onClose} messageId={canEdit ? undefined : intl.formatMessage({ id: 'actions.close' })} />
      {removeEmpty(items).length > 1 && (
        <>
          <BackButton onClick={() => changeItem({ index: previousCarouselIndex(items, activeIndex) })} />
          <ForwardButton onClick={() => changeItem({ index: nextCarouselIndex(items, activeIndex) })} />
        </>
      )}
      {canEdit && (
        <SaveButton
          onClick={onSave}
          minimumDataEntryMet={isDirty}
          saving={saveStatus === states.PENDING}
          saveText={intl.formatMessage({ id: 'actions.apply.changes' })}
        />
      )}
    </Modal.Actions>
  );
};

export default FormObjectActions;
